import React from 'react';
import { Row, Col, Tabs } from 'antd';
import { BarChartOutlined, EnvironmentOutlined, TableOutlined, UserOutlined } from '@ant-design/icons';
import { 
  CustomerLocationMap, 
  TopStatesSummary,
  StatePerformance,
  CityTableView,
  CustomerBuyingBehavior
} from './index';

const { TabPane } = Tabs;

/**
 * Component to display different views of customer data in tabs
 * @param {Object} props - Component props
 * @param {string} props.activeTab - Currently active tab key
 * @param {Function} props.setActiveTab - Function to set active tab
 * @param {Object} props.viewState - Map view state
 * @param {Function} props.setViewState - Function to update map view state
 * @param {Object} props.geoJsonData - GeoJSON data for map
 * @param {Object} props.popupInfo - Information for map popup
 * @param {Function} props.setPopupInfo - Function to set popup info
 * @param {Array} props.filteredLocations - Filtered location data
 * @param {Object} props.mapData - Map data from API including customer buying behavior data
 * @returns {JSX.Element} Tabs with different views of customer data
 */
const CustomerReportTabs = ({
  activeTab,
  setActiveTab,
  viewState,
  setViewState,
  geoJsonData,
  popupInfo,
  setPopupInfo,
  filteredLocations,
  mapData
}) => {
  console.log(mapData, "mapData")
  return (
    <Tabs 
      activeKey={activeTab} 
      onChange={setActiveTab}
      style={{ marginBottom: 16 }}
    >
      <TabPane 
        tab={<span><EnvironmentOutlined /> Map View</span>}
        key="map"
      >
        <Row gutter={[8, 8]} style={{ width: '100%' }}>
          <Col xs={24} lg={18}>
            <CustomerLocationMap 
              viewState={viewState}
              setViewState={setViewState}
              geoJsonData={geoJsonData}
              popupInfo={popupInfo}
              setPopupInfo={setPopupInfo}
            />
          </Col>
          <Col xs={24} lg={6}>
            <TopStatesSummary stateSummary={mapData.state_summary} />
          </Col>
        </Row>
      </TabPane>
      <TabPane 
        tab={<span><TableOutlined /> Table View</span>}
        key="table"
      >
        <CityTableView filteredLocations={filteredLocations} />
      </TabPane>
      <TabPane 
        tab={<span><BarChartOutlined /> State Summary</span>}
        key="state"
      >
        <StatePerformance stateSummary={mapData.state_summary} />
      </TabPane>
      <TabPane
        tab={<span><UserOutlined /> Customer Analytics</span>}
        key="analytics"
      >
        <CustomerBuyingBehavior buyingBehaviorData={mapData.customer_buying_behavior} />
      </TabPane>
    </Tabs>
  );
};

export default CustomerReportTabs;
